"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zeroDate = void 0;
// Golang's zero date, check `ApiDate` function in the backend where it specifically checks the zero date
exports.zeroDate = Object.freeze({
    full: "0001-01-01T00:00:00Z"
});
